function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.552,83.045c-1.152,0-1.844-0.045-1.844-0.045l-3.531-0.223c-0.832-0.053-1.544-0.615-1.787-1.413   c-0.243-0.797,0.034-1.662,0.695-2.169l2.816-2.163c0.662-0.509,2.291-2.289,3.679-8.011c-6.19-5.714-9.584-13.004-9.584-20.647   c0-17.324,17.497-31.419,39.004-31.419S89.004,31.05,89.004,48.374C89.004,65.697,71.507,79.79,50,79.79   c-3.907,0-7.749-0.459-11.437-1.366C32.854,82.579,24.152,83.045,20.552,83.045z M20.539,79.045c0.005,0,0.009,0,0.013,0   c3.342,0,11.618-0.422,16.271-4.334c0.5-0.421,1.177-0.569,1.808-0.4c3.644,0.981,7.469,1.479,11.37,1.479   c19.301,0,35.004-12.299,35.004-27.416c0-15.119-15.703-27.419-35.004-27.419s-35.004,12.3-35.004,27.419   c0,6.827,3.232,13.371,9.103,18.427c0.557,0.479,0.806,1.224,0.649,1.94C23.711,73.517,22.299,76.971,20.539,79.045z"
}));

function SvgMyFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFeed);
export default __webpack_public_path__ + "static/media/MyFeed.ca8c1e5d.svg";
export { ForwardRef as ReactComponent };